import { t } from "../lib/i18n";
import React from 'react';

interface CalendarEvent {
    title: string;
    start: Date;
    end: Date;
    allDay?: boolean;
    resource?: {
        type: string;
        id: string;
        property_id?: string;
        lease_id?: string;
        custom_id?: string; // Add custom_id here (for lease)
        custom_property_id?: string; // Add custom_property_id here
    };
}

interface CalendarEventModalProps {
    event: CalendarEvent | null;
    onClose: () => void;
}

const CalendarEventModal: React.FC<CalendarEventModalProps> = ({ event, onClose }) => {
    if (!event) {
        return null;
    }

    const formatDateTime = (date: Date) => {
        return new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center">
            <div className="bg-bg-secondary p-6 rounded-lg shadow-xl border border-border-primary w-11/12 md:w-1/2 lg:w-1/3">
                <h2 className="text-2xl font-bold text-text-primary mb-4">{event.title}</h2>
                <div className="mb-4 text-text-secondary">
                    <p><strong>{t("calendarEventModal.k1")}</strong> {event.resource?.type}</p>
                    <p><strong>{t("calendarEventModal.k2")}</strong> {formatDateTime(event.start)}</p>
                    <p><strong>{t("calendarEventModal.k3")}</strong> {formatDateTime(event.end)}</p>
                    {event.resource?.custom_property_id ? (
                        <p><strong>{t("calendarEventModal.k4")}</strong> {event.resource.custom_property_id}</p>
                    ) : (
                        event.resource?.property_id && <p><strong>{t("calendarEventModal.k4")}</strong> {event.resource.property_id}</p>
                    )}
                    {event.resource?.lease_id && <p><strong>{t("calendarEventModal.k5")}</strong> {event.resource.lease_id}</p>}
                    {event.resource?.custom_id && <p><strong>{t("calendarEventModal.k6")}</strong> {event.resource.custom_id}</p>}
                    <p><strong>{t("calendarEventModal.k7")}</strong> {event.resource?.id}</p>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark"
                    >
                        {t("calendarEventModal.k8")} </button>
                </div>
            </div>
        </div>
    );
};

export default CalendarEventModal;
